import { Grid, styled } from "@mui/material";
import BuildingForm from "./BuildingForm";
import { BuildingDetailProvider } from "../../context/BuildingDetailContext";
import { useBuildingsContext } from "@rf/property/module/components/property-form/septions/property-steps/buildings-step/context/Buildings-contexts/BuildingsContext";

const BuildingList = () => {
  const { fields } = useBuildingsContext();

  return (
    <ContentBuildingList container rowGap={2.5}>
      {fields.map((building, index) => (
        <BuildingDetailProvider
          key={building.uuid}
          indexBuilding={index}
          uuid={building.uuid}
        >
          <BuildingForm />
        </BuildingDetailProvider>
      ))}
    </ContentBuildingList>
  );
};

export default BuildingList;

const ContentBuildingList = styled(Grid)({
  width: "98%",
  margin: "auto",
  gap: "1rem",
  display: "flex",
  flexDirection: "column"
});
